/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Button } from 'antd';
import { FileOutlined, FileImageOutlined } from '@ant-design/icons';
import FinderJs from '../../utils/finderJS';
interface FinderButtonProps {
    multiple?: boolean;
    type?: 'file' | 'images';
    label?: string;
    onSelect?: (files: any[]) => void; // callback nhận danh sách file sau khi chọn
    style?: React.CSSProperties;
    className?: string;
    /** Hiển thị dạng nút nhỏ chỉ có icon (không text) */
    iconOnly?: boolean;
    hidden?: boolean;
    /** Icon tuỳ chỉnh — mặc định theo `type` nếu không truyền */
    icon?: React.ReactNode;
}

const FinderButton: React.FC<FinderButtonProps> = ({
    multiple = false,
    type = 'file',
    label,
    onSelect,
    style,
    className,
    iconOnly = false,
    hidden = false,
    icon,
}) => {
    const handleClick = () => {
        FinderJs.openFileManager(
            {
                multiple: multiple,
                allowedTypes: 'all'
            },
            (selectedFiles: any[]) => {
                if (selectedFiles !== null) {
                    if (onSelect) onSelect(selectedFiles);
                }
            }
        );
    };

    return (
        <Button
            // color="primary"
            // variant="outlined"
            hidden={hidden}
            className={className}
            icon={icon ?? (type === 'images' ? <FileImageOutlined /> : <FileOutlined />)}
            onClick={handleClick}
            size={iconOnly ? 'small' : 'middle'}
            type={iconOnly ? 'text' : 'default'}
            style={{
                width: iconOnly ? undefined : '100%',
                padding: iconOnly ? 0 : undefined,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                ...style,
            }}
        >
            {!iconOnly && (label || (type === 'images' ? 'Chọn hình ảnh' : 'Chọn tệp tin'))}
        </Button>
    );
};

export default FinderButton;
